import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';

import { AssignedIcon, BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

class Item extends React.Component {
    handleClick = (e) => {
        this.props.history.push(this.props.history.location.pathname + '/' + this.props.data.id);
    };

    status = (cerrada, vencida) => {
        if (cerrada) return 'cerrada';
        if (vencida) return 'vencida';
        return 'activa';
    };

    percentage = (puntos, total) => {
        if (!total) return '- %';
        else if (!puntos) return '0 %';
        else {
            return `${Math.round((puntos / total) * 100)}%`;
        }
    };

    render() {
        const { data, last } = this.props;
        const {
            creado,
            id,
            nlocal,
            puntosefectivos,
            puntosposibles,
            cerrada,
            instanciasvencida,
            instanciaesperandopormi,
            ntrabajador
        } = data;

        return (
            <div
                onClick={this.handleClick}
                className={classNames(
                    'hand flex_full_column margin_top_9 margin_left_24 ',
                    last ? 'noshadow' : 'shadow_down',
                )}
            >
                <div className={'flex_auto_column padding_bottom_9'}>
                    <div className={'margin_bottom_5 flex_full_row'}>
                        <span className={'barlow_medium c_dark_grey_blue'}>
                            {creado && creado.substr(0, 16).replace('T', ' ')}
                        </span>
                    </div>
                </div>
                <div className={'flex_full_row padding_bottom_9 align_center'}>
                    <div className={'flex_full_column '}>
                        <div className={'margin_bottom_5 flex_full_row'}>
                            <div className={'instance_check_icon_text_div'}>
                                {instanciaesperandopormi ? (
                                    <AssignedIcon color="primary" />
                                ) : (
                                    <div />
                                )}
                                <span className={'barlowcondensed_regular_number c_grey_blue'}>
                                    {id}
                                </span>
                            </div>
                        </div>
                        <div
                            className={classNames(
                                'margin_bottom_5 flex_full_row',
                                'barlow_regular_small c_grey_blue',
                            )}
                        >
                            <span> {nlocal} </span> 
                            <span className="margin_left_12 c_bluish"> {ntrabajador} </span>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            'flex_normal_column  elements_center padding_left_12',
                            'instance_check_icon_text_div',
                        )}
                    >
                        <span
                            className={
                                'barlowcondensed_light_percentage c_black_two text_align_center nowrap'
                            }
                        >
                            {this.percentage(puntosefectivos, puntosposibles)}
                        </span>
                    </div>
                    <div
                        className={classNames('flex_normal_column elements_center padding_left_12')}
                    >
                        <div
                            className={classNames('dot', this.status(cerrada, instanciasvencida))}
                        />
                    </div>
                    <div className={'flex_normal_column elements_center padding_left_12'}>
                        <BlueRightArrowIcon color="primary" />
                    </div>
                </div>
            </div>
        );
    }
}

Item.propTypes = {
    history: PropTypes.object.isRequired,
};
Item = withRouter(Item);

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

Item = connect(
    null,
    mapDispatchToProps,
)(Item);

export default Item;



// WEBPACK FOOTER //
// ./src/components/complex/instances/Item.js